
import React, { Component } from 'react';
import {
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';

import Chip from '@material-ui/core/Chip';

import TableListSort from 'core/TableListSort';
import { DateDisplay } from 'core/Display';


export default class DriverListTable extends Component {
  render() {
    const { items, onDetail } = this.props;
    return (
      <React.Fragment>
        <TableHead>
          <TableRow>
            <TableCell component="th" scope="row">
              <TableListSort label={'ФИО'} name={'last_name'} />
            </TableCell>
            <TableCell component="th" scope="row" className={'w-120'}>Дата рождения</TableCell>
            <TableCell component="th" scope="row">Водительское удостоверение</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {items.map(item =>
          <TableRow
            key={item.id}
            hover={true}
            className={'pointer'}
            onClick={(event) => onDetail(item)}
          >
            <TableCell>
              {item.full_name}
              {item.is_fired && <Chip label={'Уволен'} className={'ml-10'} size={'small'} />}
            </TableCell>
            <TableCell><DateDisplay value={item.birthday} /></TableCell>
            <TableCell>{item.driver_licence_number}</TableCell>
          </TableRow>
        )}
        </TableBody>
      </React.Fragment>
    )
  }
}
